module.exports = "<div class=\"c-display-template\" ng-style=\"vm.templateStyle\">\n  <template-block\n    ng-repeat=\"block in vm.templateBlocks track by block.id\"\n    template-block=\"block\">\n  </template-block>\n  <!-- Alert block -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/displayTemplate/displayTemplate.html
// module id = 652
// module chunks = 0